'use client';

import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormSection from './FormSection';
import FormField from './FormField';
import RadioOption from './RadioOption';
import TextInput from './TextInput';
import SelectInput from './SelectInput';
import type { RSVPFormData } from './RSVPPageClient';

const transportOptions = [
  { value: 'group', label: "🚐 I\'d like to travel with the #Vimi group" },
  { value: 'own', label: "🚗 I\'ll arrange my own transportation" },
  { value: 'train', label: "🚆 I\'ll travel by train" },
  { value: 'bus', label: "🚌 I\'ll travel by bus" },
  { value: 'undecided', label: 'Not decided yet' },
];

const cabOptions = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
  { value: 'maybe', label: 'Maybe' },
];

export default function Section6BhopalWarud() {
  const { register } = useFormContext<RSVPFormData>();

  return (
    <FormSection
      number={6}
      title="Bhopal → Warud"
      description="If you're attending the wedding, we'll help make your journey from Bhopal to Warud as easy as possible."
      infoBox={
        <>
          The wedding is in Warud, Maharashtra, approximately 350 km from
          Bhopal. Since the wedding begins early on 4 January, travelling to
          Warud on 3 January may be the most convenient option.
        </>
      }
    >
      <FormField label="How do you plan to travel from Bhopal to Warud?">
        <div className="grid gap-2 mt-1">
          {transportOptions.map((opt) => (
            <RadioOption
              key={`warud-transport-${opt.value}`}
              name="warudTransport"
              value={opt.value}
              label={opt.label}
              registerProps={register('warudTransport')}
            />
          ))}
        </div>
      </FormField>

      <FormField label="Would you like us to arrange shared transportation from Bhopal to Warud?">
        <div className="grid gap-2 mt-1">
          {cabOptions.map((opt) => (
            <RadioOption
              key={`bhopal-warud-cab-${opt.value}`}
              name="bhopalWarudCab"
              value={opt.value}
              label={opt.label}
              registerProps={register('bhopalWarudCab')}
            />
          ))}
        </div>
      </FormField>

      <FormField
        label="How many people will travel with you from Bhopal to Warud?"
        htmlFor="warudTravellers"
        helper="Include yourself in the count"
      >
        <TextInput
          id="warudTravellers"
          type="number"
          min={1}
          max={20}
          registerProps={register('warudTravellers', {
            valueAsNumber: true,
            min: 1,
            max: 20,
          })}
        />
      </FormField>

      <FormField
        label="When would you prefer to travel from Bhopal to Warud?"
        htmlFor="warudTravelDate"
      >
        <SelectInput
          id="warudTravelDate"
          registerProps={register('warudTravelDate')}
        >
          <option value="">Select preferred travel date</option>
          <option value="1 January 2027">1 January 2027</option>
          <option value="2 January 2027">2 January 2027</option>
          <option value="3 January 2027">3 January 2027</option>
          <option value="Not decided yet">Not decided yet</option>
        </SelectInput>
      </FormField>
    </FormSection>
  );
}